/*
 * @Description: 分类级联选择
 * @Author: hanpengtao
 * @Date: 2022-04-26 15:37:57
 */
import React, { useState, useEffect, useCallback } from 'react';
import { Cascader } from 'antd';
import { classifyList } from "@/api";

// 当前id对应的父级映射
const relationMap = new Map();

// 获取根据最子级id 获取cascaderValue
function getCascaderPath(value, initPath = []) {
  if (!!value) {
    initPath.unshift(value);
    const parentId = relationMap.get(value)?.id;
    if (parentId) {
      return getCascaderPath(parentId, initPath);
    }
  }

  return initPath;
}

const ClassifyCascader = (props) => {
  const { value, onChange, ...restProps } = props;

  const [classifyOptions, setClassifyOptions] = useState([]);
  const [innerValue, setInnerValue] = useState(null);

  useEffect(() => {
    getClassifyList();
  }, []);

  const getCascaderPath = useCallback((value, initPath = []) => {
    if (!!value) {
      initPath.unshift(value);
      const parentId = relationMap.get(value)?.id;
      if (parentId) {
        return getCascaderPath(parentId, initPath);
      }
    }

    return initPath;
  }, [relationMap.size]);

  useEffect(() => {
    setInnerValue(getCascaderPath(value));
  }, [value, getCascaderPath]);

  const handleChange = (ids) => {
    onChange(
      ids?.length ? ids[ids.length - 1] : null
    )
  }

  const formatClassifyData = (data, parentData = null) => {
    return data?.length
      ? data.map(item => {
        relationMap.set(item.id, parentData);

        return {
          label: item.name,
          value: item.id,
          children: formatClassifyData(
            item.level === 0 ? item.secondClassifies : item.thirdClassifies,
            item
          ),
        }
      })
      : null;
  }

  const getClassifyList = async () => {
    try {
      let res = await classifyList();
      if (res?.error?.errorCode == 0) {
        setClassifyOptions(
          formatClassifyData(res.data) ?? []
        );
      }
    } catch (error) {
      console.log('error: ', error);
    }
  }

  const filter = (inputValue, path) => {
    return path.some(option => option.label.toLowerCase().includes(inputValue.toLowerCase()));
  }

  return (
    <div className='classifyCascader'>
      <span>分类：</span>
      <Cascader
        style={{ width: 240 }}
        // changeOnSelect
        placeholder='请选择'
        expandTrigger='hover'
        showSearch={{ filter }}
        options={classifyOptions}
        value={innerValue}
        onChange={handleChange}
        {...restProps}
      />
    </div>
  )
}

export default ClassifyCascader;